import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.reduce.js";
import Product from "./Product";
import Country from "./Country";
import SalePage from "./SalePage";
import OrderLine from "./OrderLine";
import Store from "./Store";
import Inventory from "./Inventory";
import Image from "../library/Image";
import Video from "./Video";
import User from "./User";
import PreSellPage from "./PreSellPage";
import Model from "./Model";
import OfferSettings from "./offer/OfferSettings";
import { levels } from "../../../assets/js/mcn-helpers";
export class Offer extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "OfferTab", {
      id: 'offer-form-tab',
      fieldName: 'tab',
      fieldTitle: 'Offer ',
      loading: false,
      content: null
    });
    _defineProperty(this, "id", {
      id: 'form-id',
      fieldName: 'offer_id',
      fieldTitle: 'Offer id',
      content: null
    });
    _defineProperty(this, "Id", {
      id: 'form-id',
      fieldName: 'offer_id',
      fieldTitle: 'Offer id',
      content: null
    });
    _defineProperty(this, "OfferId", {
      id: 'offer-form-id',
      fieldName: 'offer_id',
      fieldTitle: 'Offer id',
      content: null
    });
    _defineProperty(this, "ProductId", {
      id: 'offer-form-product-id',
      fieldName: 'product_id',
      fieldTitle: 'Offer product id',
      content: null
    });
    _defineProperty(this, "OfferPaymentType", {
      id: 'offer-payment-type',
      fieldName: 'offer_payment_type',
      fieldTitle: 'Offer payment type',
      content: null
    });
    _defineProperty(this, "OfferDomain", {
      id: 'offer-form-id',
      fieldName: 'offer_domain',
      fieldTitle: 'Offer Domain',
      model: Store,
      content: null
    });
    _defineProperty(this, "OfferCountryID", {
      id: 'offer-form-country-id',
      fieldName: 'country_id',
      fieldTitle: 'Offer ',
      content: null
    });
    _defineProperty(this, "OfferProductID", {
      id: 'offer-form-product-id',
      fieldName: 'product_id',
      fieldTitle: 'Offer ',
      content: null
    });
    _defineProperty(this, "product", {
      id: 'product',
      fieldName: 'product',
      fieldTitle: 'Offer Product',
      model: Product,
      content: null
    });
    _defineProperty(this, "OfferProduct", {
      id: 'offer-form-product',
      fieldName: 'offer_product',
      fieldTitle: 'Offer Product',
      model: Product,
      content: null
    });
    _defineProperty(this, "activeProduct", {
      id: 'offer-form-active-product',
      fieldName: 'active_product',
      fieldTitle: 'Offer Product',
      model: Product,
      content: null
    });
    _defineProperty(this, "OfferWithTrashedProduct", {
      id: 'offer-form-product',
      fieldName: 'offer_with_trashed_product',
      fieldTitle: 'Offer Product',
      model: Product,
      content: null
    });
    _defineProperty(this, "withTrashedProduct", {
      id: 'offer-form-product',
      fieldName: 'with_trashed_product',
      fieldTitle: 'Offer Product',
      model: Product,
      content: null
    });
    _defineProperty(this, "name", {
      id: 'offer-form-name-1',
      fieldName: 'offer_name',
      fieldTitle: 'Offer Name',
      content: null,
      SideShow: true
    });
    _defineProperty(this, "OfferName", {
      id: 'offer-form-name',
      fieldName: 'offer_name',
      fieldTitle: 'Offer Name',
      content: null,
      SideShow: true
    });
    _defineProperty(this, "OfferDescription", {
      id: 'offer-form-descriptiob',
      fieldName: 'offer_description',
      fieldTitle: 'Offer Description',
      content: null
    });
    _defineProperty(this, "OfferStatus", {
      id: 'offer-form-status',
      fieldName: 'offer_status',
      fieldTitle: 'Offer Status',
      disabled: false,
      content: 'draft'
    });
    _defineProperty(this, "OfferType", {
      id: 'offer-form-type',
      fieldName: 'offer_type',
      fieldTitle: 'Offer Type',
      disabled: false,
      content: null
    });
    _defineProperty(this, "OfferPayout", {
      id: 'offer-form-payout',
      fieldName: 'offer_payout',
      fieldTitle: 'Offer Payout',
      content: null
    });
    _defineProperty(this, "OfferNetworkCommission", {
      id: 'offer-form-network-commission',
      fieldName: 'offer_network_commission',
      fieldTitle: 'Offer Network Commission',
      content: null
    });
    _defineProperty(this, "OfferPrice", {
      id: 'offer-form-price',
      fieldName: 'offer_price',
      fieldTitle: 'Offer Price',
      content: null
    });
    _defineProperty(this, "country", {
      id: 'form-country',
      fieldName: 'country',
      fieldTitle: 'Offer Country',
      model: Country,
      content: null
    });
    _defineProperty(this, "OfferCountry", {
      id: 'offer-form-country',
      fieldName: 'offer_country',
      fieldTitle: 'Offer Country',
      model: Country,
      content: null
    });
    _defineProperty(this, "OfferDate", {
      id: 'offer-form-date',
      fieldName: 'created_at',
      fieldTitle: 'Offer Date',
      content: null
    });
    _defineProperty(this, "OfferImage", {
      id: 'offer-form-image',
      fieldName: 'offer_image',
      fieldTitle: 'Offer Image',
      content: null,
      alt: 'image'
    });
    _defineProperty(this, "OfferProductAd", {
      id: 'offer-form-product-ad',
      fieldName: 'offer_product_ad_copy',
      fieldTitle: 'Offer Product Ads',
      content: null
    });
    _defineProperty(this, "OfferProductImages", {
      id: 'offer-form-images',
      fieldName: 'offer_product_ad_images',
      fieldTitle: 'Offer Product Images',
      model: Image,
      content: []
    });
    _defineProperty(this, "OfferProductVideos", {
      id: 'offer-form-videos',
      fieldName: 'offer_product_ad_videos',
      fieldTitle: 'Offer Product Videos',
      model: Video,
      content: []
    });
    _defineProperty(this, "OfferOrderLines", {
      id: 'offer-form-order-lines',
      fieldName: 'offer_order_lines',
      fieldTitle: 'Offer Order Lines',
      model: OrderLine,
      content: []
    });
    _defineProperty(this, "OfferSalePages", {
      id: 'offer-form-sale-pages',
      fieldName: 'offer_sale_pages',
      fieldTitle: 'Offer Sale Pages',
      model: SalePage,
      content: []
    });
    _defineProperty(this, "salePages", {
      id: 'offer-form-sale-pages',
      fieldName: 'offer_sale_pages',
      fieldTitle: 'Offer Sale Pages',
      model: SalePage,
      content: []
    });
    _defineProperty(this, "PreSellPages", {
      id: 'offer-form-pre-sell-pages',
      fieldName: 'pre_sell_pages',
      fieldTitle: 'Offer Pre-sell Pages',
      model: PreSellPage,
      content: []
    });
    _defineProperty(this, "preSellPages", {
      id: 'offer-form-pre-sell-pages',
      fieldName: 'pre_sell_pages',
      fieldTitle: 'Offer Pre-sell Pages',
      model: PreSellPage,
      content: []
    });
    _defineProperty(this, "OfferDefaultDomain", {
      id: 'offer-form-domain',
      fieldName: 'offer_default_domain',
      fieldTitle: 'Offer default domain',
      model: Store,
      content: null
    });
    _defineProperty(this, "OfferOfferRequestCount", {
      id: 'offer-form-request-count',
      fieldName: 'offer_offer_requests_count',
      content: 0
    });
    _defineProperty(this, "OfferOfferRequestOrderShipped", {
      id: 'offer-form-request-order-shipped',
      fieldName: 'offer_offer_requests_order_shipped',
      content: ''
    });
    _defineProperty(this, "OfferRequiredActivityScore", {
      fieldName: 'offer_required_activity_points',
      content: 0
    });
    _defineProperty(this, "OfferInventories", {
      id: 'offer-form-inventories',
      fieldName: 'offer_inventories',
      model: Inventory,
      content: []
    });
    _defineProperty(this, "OfferExclusiveUsers", {
      id: 'offer-form-exclusive-users',
      fieldName: 'offer_exclusive_users',
      model: User,
      content: []
    });
    _defineProperty(this, "ShippingCountriesSelectType", {
      fieldName: 'shipping_countries_select_type',
      content: Offer.MULTIPLE_COUNTRY_SELECT_TYPE
    });
    _defineProperty(this, "ShippingCountries", {
      fieldName: 'offer_shipping_countries',
      model: Country,
      content: []
    });
    _defineProperty(this, "SalePrice", {
      fieldName: 'sale_price',
      content: null
    });
    _defineProperty(this, "StatusRequiredForCommission", {
      fieldName: 'status_required_for_commission',
      content: null
    });
    _defineProperty(this, "settings", {
      fieldName: 'settings',
      model: OfferSettings,
      content: new OfferSettings()
    });
  }
  getSettings() {
    return this.settings.content;
  }
  getStatistics() {
    let settings = this.getSettings();
    return settings instanceof OfferSettings ? settings.getStatistics() : null;
  }
  getId() {
    var _this$Id;
    return (_this$Id = this.Id) === null || _this$Id === void 0 ? void 0 : _this$Id.content;
  }
  getImage() {
    let product = this.getOfferProduct();
    return product instanceof Product ? product.getImage() : null;
  }
  getSalePrice() {
    return this.SalePrice.content;
  }
  getSalePages() {
    var _this$OfferSalePages$;
    return (_this$OfferSalePages$ = this.OfferSalePages.content) !== null && _this$OfferSalePages$ !== void 0 ? _this$OfferSalePages$ : this.salePages.content;
  }
  getDescription() {
    return this.OfferDescription.content;
  }
  getImageUrl() {
    let image = this.getImage();
    return image instanceof Image ? image.getUrl() : null;
  }
  getOfferId() {
    var _this$OfferId;
    return (_this$OfferId = this.OfferId) === null || _this$OfferId === void 0 ? void 0 : _this$OfferId.content;
  }
  getOfferProduct() {
    var _this$OfferProduct$co, _this$OfferProduct, _this$activeProduct;
    return (_this$OfferProduct$co = (_this$OfferProduct = this.OfferProduct) === null || _this$OfferProduct === void 0 ? void 0 : _this$OfferProduct.content) !== null && _this$OfferProduct$co !== void 0 ? _this$OfferProduct$co : (_this$activeProduct = this.activeProduct) === null || _this$activeProduct === void 0 ? void 0 : _this$activeProduct.content;
  }
  getPreSellPages() {
    var _this$PreSellPages$co;
    return (_this$PreSellPages$co = this.PreSellPages.content) !== null && _this$PreSellPages$co !== void 0 ? _this$PreSellPages$co : this.preSellPages.content;
  }
  getProduct(trashed = false) {
    var _this$OfferWithTrashe, _this$OfferProduct$co2;
    if (trashed) return (_this$OfferWithTrashe = this.OfferWithTrashedProduct.content) !== null && _this$OfferWithTrashe !== void 0 ? _this$OfferWithTrashe : this.withTrashedProduct.content;
    return (_this$OfferProduct$co2 = this.OfferProduct.content) !== null && _this$OfferProduct$co2 !== void 0 ? _this$OfferProduct$co2 : this.product.content;
  }
  getProductId() {
    var _this$ProductId;
    return (_this$ProductId = this.ProductId) === null || _this$ProductId === void 0 ? void 0 : _this$ProductId.content;
  }
  getPaymentType() {
    return this.OfferPaymentType.content;
  }
  isCardPaymentType() {
    return this.getPaymentType() === Offer.CARD_PAYMENT_TYPE;
  }
  getShippingCountriesSelectType() {
    return this.ShippingCountriesSelectType.content;
  }
  isWorldWide() {
    return this.getShippingCountriesSelectType() === Offer.WORLD_WIDE_COUNTRY_SELECT_TYPE;
  }
  isMultipleCountries() {
    return this.getShippingCountriesSelectType() === Offer.MULTIPLE_COUNTRY_SELECT_TYPE;
  }
  isSingleCountry() {
    return this.getShippingCountriesSelectType() === Offer.SAME_COUNTRY_SELECT_TYPE;
  }
  getOfferProductName() {
    var _this$getOfferProduct;
    return (_this$getOfferProduct = this.getOfferProduct()) === null || _this$getOfferProduct === void 0 || (_this$getOfferProduct = _this$getOfferProduct.ProductName) === null || _this$getOfferProduct === void 0 ? void 0 : _this$getOfferProduct.content;
  }
  getOfferProductImage() {
    var _this$getOfferProduct2;
    return (_this$getOfferProduct2 = this.getOfferProduct()) === null || _this$getOfferProduct2 === void 0 || (_this$getOfferProduct2 = _this$getOfferProduct2.ProductImage) === null || _this$getOfferProduct2 === void 0 ? void 0 : _this$getOfferProduct2.content;
  }
  getOfferProductImageUrl() {
    var _this$getOfferProduct3;
    return (_this$getOfferProduct3 = this.getOfferProductImage()) === null || _this$getOfferProduct3 === void 0 || (_this$getOfferProduct3 = _this$getOfferProduct3.ImageUrl) === null || _this$getOfferProduct3 === void 0 ? void 0 : _this$getOfferProduct3.content;
  }
  getShippingCountries() {
    var _this$ShippingCountri;
    return (_this$ShippingCountri = this.ShippingCountries.content) !== null && _this$ShippingCountri !== void 0 ? _this$ShippingCountri : [];
  }
  getCountryNameTranslationWithEmoji(lang) {
    let country = this.getOfferCountry();
    return country instanceof Country ? country.getNameTranslationWithEmoji(lang) : null;
  }
  getCountry() {
    var _this$OfferCountry$co;
    return (_this$OfferCountry$co = this.OfferCountry.content) !== null && _this$OfferCountry$co !== void 0 ? _this$OfferCountry$co : this.country.content;
  }
  getOfferPayout() {
    var _this$OfferPayout;
    return (_this$OfferPayout = this.OfferPayout) === null || _this$OfferPayout === void 0 ? void 0 : _this$OfferPayout.content;
  }
  getPayout() {
    var _this$OfferPayout2;
    return (_this$OfferPayout2 = this.OfferPayout) === null || _this$OfferPayout2 === void 0 ? void 0 : _this$OfferPayout2.content;
  }
  getOfferCountry() {
    var _this$OfferCountry;
    return (_this$OfferCountry = this.OfferCountry) === null || _this$OfferCountry === void 0 ? void 0 : _this$OfferCountry.content;
  }
  getOfferName() {
    return this.OfferName.content;
  }
  getName() {
    var _this$OfferName$conte;
    return (_this$OfferName$conte = this.OfferName.content) !== null && _this$OfferName$conte !== void 0 ? _this$OfferName$conte : this.name.content;
  }
  getOfferCommission() {
    var _this$OfferNetworkCom;
    return (_this$OfferNetworkCom = this.OfferNetworkCommission) === null || _this$OfferNetworkCom === void 0 ? void 0 : _this$OfferNetworkCom.content;
  }
  getStatus() {
    return this.OfferStatus.content;
  }
  getOfferSelectObject(text = 'text', value = 'value') {
    var _this$OfferName, _this$OfferId2;
    return {
      [text]: (_this$OfferName = this.OfferName) === null || _this$OfferName === void 0 ? void 0 : _this$OfferName.content,
      [value]: (_this$OfferId2 = this.OfferId) === null || _this$OfferId2 === void 0 ? void 0 : _this$OfferId2.content
    };
  }
  statusRequiredForCommission() {
    return this.StatusRequiredForCommission.content;
  }
  getStatusRequiredForCommission() {
    return this.StatusRequiredForCommission.content;
  }
  canBeShippedOutdoor() {
    return [Offer.MULTIPLE_COUNTRY_SELECT_TYPE, Offer.WORLD_WIDE_COUNTRY_SELECT_TYPE].includes(this.getShippingCountriesSelectType());
  }
  getType() {
    return this.OfferType.content;
  }
  isStandard() {
    return this.getType() === Offer.STANDARD_TYPE;
  }
  getCurrencySymbol() {
    if (this.canBeShippedOutdoor()) return null;
    let country = this.getCountry();
    return country instanceof Country ? country.getCurrencySymbol() : null;
  }
  getRequiredActivityScore() {
    return this.OfferRequiredActivityScore.content;
  }
  getLevel() {
    var _levels$find;
    let levelPoints = levels.reduce((init, level) => {
      if (level.points > this.getRequiredActivityScore()) return init;
      return level.points > init ? level.points : init;
    }, 0);
    return (_levels$find = levels.find(level => level.points === levelPoints)) === null || _levels$find === void 0 ? void 0 : _levels$find.level_sym;
  }
}
_defineProperty(Offer, "ACTIVE_STATUS", 'active');
_defineProperty(Offer, "PAUSED_STATUS", 'paused');
_defineProperty(Offer, "DRAFT_STATUS", 'draft');
_defineProperty(Offer, "STANDARD_TYPE", 'standard');
_defineProperty(Offer, "VIP_TYPE", 'vip');
_defineProperty(Offer, "EXCLUSIVE_TYPE", 'exclusive');
_defineProperty(Offer, "PRIVATE_TYPE", 'private');
_defineProperty(Offer, "TEST_TYPE", 'test');
_defineProperty(Offer, "COD_PAYMENT_TYPE", 'cod');
_defineProperty(Offer, "CARD_PAYMENT_TYPE", 'card');
_defineProperty(Offer, "CARD_PAYMENT_TYPE_ALTERNATIVE", 'pre-paid');
_defineProperty(Offer, "SAME_COUNTRY_SELECT_TYPE", 'same-country');
_defineProperty(Offer, "WORLD_WIDE_COUNTRY_SELECT_TYPE", 'world-wide');
_defineProperty(Offer, "MULTIPLE_COUNTRY_SELECT_TYPE", 'multiple-countries');
_defineProperty(Offer, "OPTION_VALUE_KEY", 'Id.content');
_defineProperty(Offer, "OPTION_TEXT_KEY", 'OfferName.content');
_defineProperty(Offer, "CONFIRMED_COMMISSION_TYPE", 'confirmed');
_defineProperty(Offer, "DELIVERED_COMMISSION_TYPE", 'delivered');
export default Offer;